var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#00AFAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1509 21.3637L27.9392 20L27.1509 18.6363L30.7188 17.6808L32.2562 11.9457L28.0586 7.74593L22.3236 9.28339L21.3681 12.8512L20.0022 12.063L18.6384 12.8512L17.683 9.28339L11.9479 7.74593L7.75027 11.9457L9.28773 17.6808L12.8556 18.6363L12.0673 20L12.8556 21.3637L9.28773 22.3192L7.75027 28.0543L11.9479 32.2541L17.683 30.7166L18.6384 27.1487L20.0022 27.937L21.3681 27.1487L22.3236 30.7166L28.0586 32.2541L32.2562 28.0543L30.7188 22.3192L27.1509 21.3637ZM27.5375 30.3214L23.7351 29.3029L22.4539 24.5212L20 25.937L17.5461 24.5212L16.2649 29.3029L12.4625 30.3214L9.67861 27.5375L10.6971 23.7351L15.481 22.4539L14.0651 20L15.481 17.5461L10.6992 16.2649L9.68078 12.4625L12.4647 9.67861L16.2671 10.6971L17.5483 15.4788L20.0022 14.063L22.456 15.4788L23.7372 10.6971L27.5396 9.67861L30.3236 12.4625L29.3051 16.2649L24.5233 17.5461L25.9392 20L24.5233 22.4539L29.3051 23.7351L30.3236 27.5375L27.5396 30.3214H27.5375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9978 18.063L21.2269 18.7709L21.9349 20L21.2269 21.2269L19.9978 21.937L18.7709 21.2269L18.063 20L18.7709 18.7709L19.9978 18.063Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logoShort.d075b4cbc61adcbefae15392409932b5.svg";
export { ForwardRef as ReactComponent };